<form [formGroup]="verificationForm" class="page-layout wrapper" *transloco="let t">
  <img alt="Moje iSophi" src="assets/img/logo/logo_MojeiSophi_black.svg" class="logo" />

  <div class="phone-wrapper">
    <!-- Title -->
    <div class="title">
      <i class="material-symbols-rounded">mobile</i>
      <h1>{{ t('verification/phoneNumber') }}</h1>
    </div>

    <!-- Phone number send -->
    <ng-container *ngIf="!verificationSent">
      <span class="regular-text">{{ t('verification/verifyPhoneDescription') }}</span>
      <app-text-input
        [childForm]="verificationForm"
        formControlName="phoneNumber"
        [label]="t('verification/phone')"
        [placeholder]="'+421999888777'"
        [required]="true"
        [requiredColor]="true"
      ></app-text-input>
      <span class="regular-text text-gray">{{ t('verification/phoneVerificationInfo') }}</span>

      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="isSendingCode || verificationForm.controls.phoneNumber.invalid"
        (click)="onSendVerificationCode(verificationForm.value.phoneNumber)"
      >
        <span *ngIf="!isSendingCode">{{ t('verification/sendVerificationCode') }}</span>
        <span *ngIf="isSendingCode">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ t('verification/sending') }}
        </span>
      </button>
    </ng-container>

    <!-- Verification code -->
    <ng-container *ngIf="verificationSent">
      <span
        class="regular-text"
        [innerHTML]="t('verification/enterVerificationCode', { phoneNumber: verificationForm.value.phoneNumber })"
      ></span>
      <app-text-input
        class="code-input"
        [childForm]="verificationForm"
        [formControlError]="t('verification/codeError')"
        [placeholder]="'- - - - - -'"
        formControlName="code"
      ></app-text-input>
      <!-- Send again -->
      <span class="regular-text text-gray send-again"
        >{{ t('verification/codeNotSend') }}
        <u (click)="onResendCode()">
          <span *ngIf="!isSendingCode && resendCooldownSeconds === 0">{{ t('shared/sendAgain') }}</span>
          <span *ngIf="!isSendingCode && resendCooldownSeconds > 0"> {{ t('shared/sendAgain') }} ({{ resendCooldownSeconds }}s) </span>
          <span *ngIf="isSendingCode">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ t('verification/sending') }}
          </span>
        </u>
      </span>

      <button
        type="button"
        class="btn btn-primary btn-lg col-12 mt-3"
        [disabled]="isVerifying || verificationForm.controls.code.invalid"
        (click)="onVerifyCode()"
      >
        <span *ngIf="!isVerifying">{{ t('registration/next') }}</span>
        <span *ngIf="isVerifying">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ t('verification/verifying') }}
        </span>
      </button>

      <button type="button" class="btn btn-outline-primary" (click)="stepBack()">
        {{ t('registration/back') }}
      </button>
    </ng-container>
  </div>
</form>
